module.exports = __webpack_public_path__ + "static/media/small-arrow-down.1799e480.svg";